const italianPageData = {
  slug: 'italian',
  code: 'it',
  name: 'Italian',
  nativeName: 'Italiano',
  flag: '🇮🇹',
  accent: 'from-emerald-500 to-red-500',
  description: 'Summary notes and quick references for Italian learners.',
  notes: { summary: [], keyPoints: [], quickReference: [] },
};

export default italianPageData;
